import { Button as DefaultButton } from 'components';
import styled from 'styled-components';

export const UpgradeButton = styled(DefaultButton)`
  margin-top: ${({ theme }) => theme.spacing.lg};
`;
